import React from 'react'
import PropTypes from 'prop-types'

// Components
import Route1 from './route1'
import Route2 from './route2'
import Route3 from './route3'
import Route4 from './route4'

// Styles
import { ExpeditionRouteMain } from './index.style'

const ExpeditionRoute = ({
  id,
  backgroundColor,
  labelColor,
  expeditionNumber,
}) => {
  const getExpeditionRoute = number => {
    switch (number) {
      case '1':
        return Route1
      case '2':
        return Route2
      case '3':
        return Route3
      case '4':
        return Route4
      default:
        console.error('Invalid Expedition Number')
    }
  }

  const getRouteSize = number => {
    switch (number) {
      case '1':
        return [40, 45]
      case '2':
        return [47.5, 44.4]
      case '3':
        return [60.7, 42.5]
      case '4':
        return [36.3, 41.8]
      default:
        console.error('Invalid Expedition Number')
    }
  }

  const SingleRoute = getExpeditionRoute(expeditionNumber),
    RouteSize = getRouteSize(expeditionNumber)

  return (
    <ExpeditionRouteMain vWidth={RouteSize[0]} vHeight={RouteSize[1]}>
      {SingleRoute && (
        <SingleRoute
          id={id}
          backgroundColor={backgroundColor}
          labelColor={labelColor}
        />
      )}
    </ExpeditionRouteMain>
  )
}

ExpeditionRoute.propTypes = {
  id: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  labelColor: PropTypes.string,
  expeditionNumber: PropTypes.string,
}

export default ExpeditionRoute
